import React, { useEffect, useRef } from 'react';

export function fitTextarea(textarea: HTMLTextAreaElement) {
  textarea.style.height = 'auto';
  textarea.style.height = `${Math.max(36, textarea.scrollHeight)}px`;
}

export function AutoGrowTextarea(props: React.TextareaHTMLAttributes<HTMLTextAreaElement>) {
  const ref = useRef<HTMLTextAreaElement | null>(null);

  useEffect(() => {
    if (ref.current) fitTextarea(ref.current);
  }, [props.defaultValue]);

  return (
    <textarea
      {...props}
      ref={ref}
      onInput={(event) => {
        fitTextarea(event.currentTarget);
        props.onInput?.(event);
      }}
      onFocus={(event) => {
        fitTextarea(event.currentTarget);
        props.onFocus?.(event);
      }}
    />
  );
}
